function isPlainObject(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
function isEquatable(value) {
    return typeof value.equals === 'function';
}
/**
 * Structural equality for render props: arrays and plain objects compare by value, value types
 * exposing `equals` (THREE vectors, quaternions, eulers) compare via it, everything else by identity.
 */
export function deepValueEqual(a, b) {
    if (Object.is(a, b))
        return true;
    if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object')
        return false;
    if (Array.isArray(a) || Array.isArray(b)) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length)
            return false;
        for (let index = 0; index < a.length; index += 1) {
            if (!deepValueEqual(a[index], b[index]))
                return false;
        }
        return true;
    }
    if (isPlainObject(a) && isPlainObject(b)) {
        const aRecord = a;
        const bRecord = b;
        const aKeys = Object.keys(aRecord);
        if (aKeys.length !== Object.keys(bRecord).length)
            return false;
        for (const key of aKeys) {
            if (!Object.prototype.hasOwnProperty.call(bRecord, key))
                return false;
            if (!deepValueEqual(aRecord[key], bRecord[key]))
                return false;
        }
        return true;
    }
    if (Object.getPrototypeOf(a) === Object.getPrototypeOf(b) && isEquatable(a))
        return a.equals(b);
    return false;
}
/** `React.memo` comparator that skips re-rendering when props are equal by value. */
export function areRenderPropsValueEqual(previous, next) {
    return deepValueEqual(previous, next);
}
